


















































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import PicView from "@/components/pic-preview.vue";
@Component({
  components: {
    PicView,
  },
})
export default class SzsxMoniResultDuoxuan extends Vue {
  @Prop()
  private question;
  @Prop()
  private index;
  @Prop()
  private filters;
  @Prop()
  private answer;
  private ifShowPic: boolean = false;
  private index2Alpha: any[] = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
  ];
  /**
   * @description 判断是否被选中
   */
  private ifSelect(oi) {
    if (!this.answer || !this.answer["reply"]) {
      return false;
    }
    const inx = this.answer["reply"].indexOf(oi);
    if (inx !== -1) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * @description 判断是否答对
   */
  private ifCorrect(oi) {
    if (this.answer["正确答案"].indexOf(oi) !== -1) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * @description 没有选择但是答案在正确答案里
   */
  private ifInCorrect(oi) {
    if (this.answer["正确答案"].indexOf(oi) !== -1) {
      return true;
    } else {
      return false;
    }
  }
}
